import { writable } from 'svelte/store'

export const name = writable(localStorage.getItem("name") || "")
name.subscribe(val => localStorage.setItem("name", val));

export const sex = writable(localStorage.getItem("sex") || "")
sex.subscribe(val => localStorage.setItem("sex", val));

export const age = writable(localStorage.getItem("age") || "")
age.subscribe(val => localStorage.setItem("age", val));

export const residence = writable(localStorage.getItem("residence") || "")
residence.subscribe(val => localStorage.setItem("residence", val));

export const visitor = writable(localStorage.getItem("visitor") || "NO")
visitor.subscribe(val => localStorage.setItem("visitor", val));

export const visitPurpose = writable(localStorage.getItem("visitPurpose") || "")
visitPurpose.subscribe(val => localStorage.setItem("visitPurpose", val));

export const visitCompany = writable(localStorage.getItem("visitCompany") || "")
visitCompany.subscribe(val => localStorage.setItem("visitCompany", val));

export const visitAddress = writable(localStorage.getItem("visitAddress") || "")
visitAddress.subscribe(val => localStorage.setItem("visitAddress", val));

export const idNumber = writable(localStorage.getItem("idNumber") || "")
idNumber.subscribe(val => localStorage.setItem("idNumber", val));

export const department = writable(localStorage.getItem("department") || "")
department.subscribe(val => localStorage.setItem("department", val));

export const temp = writable(localStorage.getItem("temp") || "")
temp.subscribe(val => localStorage.setItem("temp", val))

export const soreThroat = writable(localStorage.getItem("soreThroat") || "")
soreThroat.subscribe(val => localStorage.setItem("soreThroat", val));

export const bodyPains = writable(localStorage.getItem("bodyPains") || "")
bodyPains.subscribe(val => localStorage.setItem("bodyPains", val));

export const headache = writable(localStorage.getItem("headache") || "")
headache.subscribe(val => localStorage.setItem("headache", val));

export const fever = writable(localStorage.getItem("fever") || "")
fever.subscribe(val => localStorage.setItem("fever", val));

export const covidContact = writable(localStorage.getItem("covidContact") || "")
covidContact.subscribe(val => localStorage.setItem("covidContact", val));

export const supsectContact = writable(localStorage.getItem("supsectContact") || "")
supsectContact.subscribe(val => localStorage.setItem("supsectContact", val));

export const travelAbroad = writable(localStorage.getItem("travelAbroad") || "")
travelAbroad.subscribe(val => localStorage.setItem("travelAbroad", val));

export const travelCity = writable(localStorage.getItem("travelCity") || "NO")
travelCity.subscribe(val => localStorage.setItem("travelCity", val));

export const triage = writable(localStorage.getItem("triage") || "")
triage.subscribe(val => localStorage.setItem("triage", val));

export const triageDesc = writable(localStorage.getItem("triageDesc") || "")
triageDesc.subscribe(val => localStorage.setItem("triageDesc", val));

export const time = writable(localStorage.getItem("time") || "")
time.subscribe(val => localStorage.setItem("time", val));